import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
{
    id: "po-07-h2v5-01",
    name: "PO 01 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 53, y: 240, width: 265, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 431, width: 265, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 326, y: 240, width: 235, height: 371, rotation: 0, imageRotation: 0 },
            { id: "4", x: 708, y: 112, width: 201, height: 310, rotation: 0, imageRotation: 0 },
            { id: "5", x: 708, y: 431, width: 201, height: 309, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 112, width: 200, height: 310, rotation: 0, imageRotation: 0 },
            { id: "7", x: 917, y: 431, width: 200, height: 309, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-02",
    name: "PO 02 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 53, y: 240, width: 265, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 431, width: 265, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 326, y: 240, width: 235, height: 371, rotation: 0, imageRotation: 0 },
            { id: "4", x: 664, y: 165, width: 374, height: 521, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1046, y: 165, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1046, y: 341, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1046, y: 518, width: 111, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-03",
    name: "PO 03 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 64, y: 165, width: 493, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 446, width: 333, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 446, width: 151, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 664, y: 165, width: 374, height: 521, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1046, y: 165, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1046, y: 341, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1046, y: 518, width: 111, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-04",
    name: "PO 04 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 63, y: 165, width: 377, height: 256, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 430, width: 377, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 448, y: 165, width: 108, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 448, y: 341, width: 108, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 448, y: 518, width: 108, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 663, y: 228, width: 242, height: 393, rotation: 0, imageRotation: 0 },
            { id: "7", x: 913, y: 228, width: 242, height: 393, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-05",
    name: "PO 05 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 51, y: 216, width: 265, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 324, y: 216, width: 245, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 324, y: 430, width: 245, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 664, y: 165, width: 374, height: 521, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1046, y: 165, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1046, y: 341, width: 111, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1046, y: 518, width: 111, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-06",
    name: "PO 06 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 97, y: 171, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 430, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 171, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 259, y: 430, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 419, y: 171, width: 327, height: 509, rotation: 0, imageRotation: 0 },
            { id: "6", x: 755, y: 171, width: 364, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 755, y: 430, width: 364, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-07",
    name: "PO 07 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 98, y: 172, width: 153, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 260, y: 172, width: 153, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 421, y: 172, width: 363, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 98, y: 430, width: 363, height: 249, rotation: 0, imageRotation: 0 },
            { id: "5", x: 469, y: 430, width: 153, height: 249, rotation: 0, imageRotation: 0 },
            { id: "6", x: 631, y: 430, width: 153, height: 249, rotation: 0, imageRotation: 0 },
            { id: "7", x: 793, y: 172, width: 327, height: 507, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-08",
    name: "PO 08 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 275, width: 186, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 194, y: 275, width: 186, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 389, y: 275, width: 440, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 837, y: 275, width: 186, height: 300, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1031, y: 275, width: 186, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1031, y: 430, width: 89, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1128, y: 430, width: 89, height: 146, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-09",
    name: "PO 09 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 98, y: 172, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 431, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 172, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 260, y: 431, width: 153, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 421, y: 172, width: 364, height: 250, rotation: 0, imageRotation: 0 },
            { id: "6", x: 421, y: 431, width: 364, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 794, y: 172, width: 326, height: 509, rotation: 0, imageRotation: 0 }
    ],
},

//{
//    id: "po-07-h2v5-10",
//    name: "PO 10 - H2V5",
//    albumType: "PO",
//    thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
//    size: [1217, 851],
//    style: {},
//    slots: [
//            { id: "1", x: 85, y: 0, width: 592, height: 851, rotation: 0, imageRotation: 0 },
//            { id: "2", x: 685, y: 0, width: 181, height: 278, rotation: 0, imageRotation: 0 },
//            { id: "3", x: 685, y: 286, width: 181, height: 278, rotation: 0, imageRotation: 0 },
//            { id: "4", x: 685, y: 573, width: 181, height: 278, rotation: 0, imageRotation: 0 },
//            { id: "5", x: 874, y: 0, width: 257, height: 421, rotation: 0, imageRotation: 0 },
//            { id: "6", x: 874, y: 430, width: 257, height: 421, rotation: 0, imageRotation: 0 },
//             { id: "7", x: 874, y: 430, width: 600, height: 421, rotation: 0, imageRotation: 0 }
//    ],
//}
];